<!--
 * @Description: 游戏管理分区列表
 * @Author: gao shuai
 * @Date: 2020-02-23 14:13:50
 * @LastEditTime: 2020-09-11 09:27:12
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
        <el-breadcrumb-item>分区列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>创建时间：</span>
          <span class="txtbox">
            <el-date-picker style="width:185px;" size="small" value-format="yyyy-MM-dd HH:mm:ss" v-model="createtime" type="datetime" placeholder="选择日期时间">
            </el-date-picker>
          </span>
        </li>
        <li>
          <span class='tit'>开区时间：</span>
          <span class="txtbox">
            <el-date-picker style="width:185px;" size="small" value-format="yyyy-MM-dd HH:mm:ss" v-model="openinghours" type="datetime" placeholder="选择日期时间">
            </el-date-picker>
          </span>
        </li>
        <li>
          <span class='tit'>商户ID：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="tenantId" @input="tenantId=intNumber(tenantId)" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>商户账号：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="accountnumber" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>启用状态：</span>
          <span class="txtbox">
            <el-select style="width:120px;" v-model="statu" clearable size="small" placeholder="请选择">
              <el-option v-for="(item,i) in statudrow" :key="'statu'+i" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </span>
        </li>
        <li>
          <span class='tit'>游戏分组：</span>
          <span class="txtbox">
            <el-select style="width:140px;" v-model="gamegroups" clearable size="small" placeholder="请选择">
              <el-option v-for="(item,i) in gamedrow" :key="'game'+i" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </span>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="()=>{pageIndex=1;getlist()}">查询</el-button>
          </span>
        </li>
      </ul>
    </div>
    <div class="gs_tablebox">
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column type="index" label="编号" width="60"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="110">
          <template slot-scope="scope">
            <p style="color:#010101;height:18px;">{{scope.row.createDate.split(' ')[0]}}</p>
            <p style="color:#969a9b;height:18px;">{{scope.row.createDate.split(' ')[1]}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="分区名称" width="240"></el-table-column>
        <el-table-column prop="useDate" label="分区时间" width="110">
          <template slot-scope="scope">
            <p style="color:#010101;height:18px;">{{scope.row.useDate.split(' ')[0]}}</p>
            <p style="color:#969a9b;height:18px;">{{scope.row.useDate.split(' ')[1]}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="useName" label="开区使用名称"></el-table-column>
        <el-table-column prop="serverIp" label="通讯IP"></el-table-column>
        <el-table-column prop="serverPort" label="通讯端口"></el-table-column>
        <el-table-column prop="scriptPath" label="分区目录"></el-table-column>
        <el-table-column prop="account" label="商户账号"></el-table-column>
        <el-table-column prop="name" label="操作" width='100'>
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="recharge(scope.row.uuid)">充值</el-button>
            <!-- <el-button size="mini" type="danger" @click="checklink(scope.row.id,scope.$index)" :loading="!checkflag&&checkIndex===scope.$index">检测</el-button> -->
            <!-- <el-button size="mini" type="primary" @click="handleClose(scope.row.id)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      createtime: this.getCerentTime(true), // 创建时间
      openinghours: this.getCerentTime(false), // 开区时间
      checkflag: true, // 检测的flag
      checkIndex: '', // 检测的Index
      tenantId: '', // 商户ID
      accountnumber: '', // 商户帐号
      statu: '', // 启用状态
      statudrow: [
        { value: 1, text: '启用' },
        { value: 0, text: '禁用' }
      ], // 启用状态下拉
      gamegroups: '', // 游戏分组
      gamedrow: [], // 游戏分组下拉
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      tableData: []
    };
  },
  methods: {
    // 分组list
    getlist() {
      this.$api.game
        .gamelist({
          CreateDate: this.createtime,
          UseDate: this.openinghours,
          ApplicationUserId: this.tenantId,
          Account: this.accountnumber,
          GroupId: this.gamegroups,
          State: this.statu === '' ? -1 : this.statu,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 充值
    recharge(uuid) {
      var tempwindow = window.open();
      this.$api.game
        .getnetarea({ typeId: 0 })
        .then((data) => {
          if (data.status === 200) {
            // window.open(data.data + '/recharge/' + uuid, '_blank');
            tempwindow.location = data.data + '/recharge/' + uuid;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 游戏分组下拉
    gamedrowlist() {
      this.$api.game
        .gamepull()
        .then((data) => {
          if (data.status === 204) {
            this.gamedrow = [];
          } else if (data.status === 200) {
            this.gamedrow = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 游戏删除请求
    gamedelete(data) {
      this.$api.game
        .gamedelete({ id: data })
        .then(() => {
          this.$messageSuccess('删除成功！');
          if (this.tableData.length === 1) {
            this.pageIndex = this.pageIndex === 1 ? 1 : this.pageIndex - 1;
          }
          this.getlist();
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 游戏删除
    handleClose(data) {
      this.$confirm('删除分区会删除该分区的订单记录和补发记录,是否删除?')
        .then(() => {
          this.gamedelete(data);
        })
        .catch(() => {});
    },
    // 分区检测
    checklink(id, index) {
      if (this.checkflag) {
        this.checkflag = false;
        this.checkIndex = index;
        this.$api.game
          .checkLink({
            partitionId: id
          })
          .then((data) => {
            if (data.status === 200) {
              this.$messageSuccess('检测成功！');
              this.checkflag = true;
              this.checkIndex = '';
            }
          })
          .catch(() => {
            this.checkflag = true;
            this.checkIndex = '';
            this.$messageError('检测失败！');
          });
      }
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    }
  },
  created() {
    this.getlist();
    this.gamedrowlist();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.tableinfo {
  background: #fff;
  padding: 15px 20px;
  table {
    width: 100%;
    color: #272727;
    font-size: 14px;
    td {
      height: 30px;
    }
    .c_3fa396 {
      color: #3fa396;
    }
  }
}
</style>
